import Vue from 'vue';
import Store from '@/store';

export const API_NAME = {
  getPageInfo: '/web/template/getPageInfo',
  doTask: '/web/template/doTask',
  queryRewardType: '/web/reward/queryType',
  getAwards: '/web/reward/query',
  address: '/web/reward/queryGoodsAddress',
  getShareCode: '/web/invitation/shareCode',
  saveAddress: '/web/reward/addGoodsAddress',
  getInviteePageInfo: '/web/invitation/addInvitee',
  addInviteTask: '/web/addInviteHelpTask',
  addInviteeTask: '/web/invitation/addInvitee',
  getActivityTaskLog: '/web/activityTaskLog',
  getXlWxaQRCode: '/qrCode/wechat'
};
const getCommonData = () => {
  return {
    locationInfo: Store.state.app && Store.state.app.locationObj
  };
};

const doBasePost = (api, data = {}) => {
  return Vue.prototype.$request.post(api, {
    ...getCommonData(),
    ...data
  });
};

export const getPageInfo = code => {
  return doBasePost(API_NAME.getPageInfo, {
    code
  });
};

export const getInviteePageInfo = data => {
  return doBasePost(API_NAME.getInviteePageInfo, {
    ...data,
    excuteTask: false
  });
};

export const submitDraw = data => {
  return doBasePost(API_NAME.doTask, data);
};

export const doTask = data => {
  return doBasePost(API_NAME.doTask, data);
};

export const queryRewardType = (data = {}) => {
  return doBasePost(API_NAME.queryRewardType, data);
};

export const getMyAwards = (data = {}) => {
  return doBasePost(API_NAME.getAwards, data);
};

export const getUserAddress = () => {
  return doBasePost(API_NAME.address);
};

export const fetchShareCode = data => {
  return doBasePost(API_NAME.getShareCode, data);
};

export const reportInvited = data => {
  return doBasePost(API_NAME.reportInvited, data);
};

export const addInviteTask = data => {
  return doBasePost(API_NAME.addInviteTask, data);
};

export const getActivityTaskLog = data => {
  return doBasePost(API_NAME.getActivityTaskLog, data);
};

export const getXlWxaQRCode = data => {
  return doBasePost(API_NAME.getXlWxaQRCode, data);
};

export const addInviteeTask = data => {
  return doBasePost(API_NAME.addInviteeTask, {
    ...data,
    excuteTask: true
  });
};
